import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { FaPowerOff, FaSyncAlt, FaExclamationTriangle, FaShieldAlt } from 'react-icons/fa';
import './css/siteSettings.css'; // Yeni oluşturduğun CSS'i import et

const SiteSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const fetchSiteSettings = () => {
    setLoading(true);
    axiosInstance.get('/siteSettings')
      .then(response => setSettings(response.data))
      .catch(err => setError(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchSiteSettings();
  }, []);

  const toggleBonusRequests = () => {
    if (!settings) return;
    const newStatus = !settings.bonusRequestsEnabled;
    setIsUpdating(true);
    axiosInstance.post('/siteSettings/update', { status: newStatus })
      .then(() => setSettings(prev => ({ ...prev, bonusRequestsEnabled: newStatus })))
      .catch(err => console.error("Güncelleme hatası:", err))
      .finally(() => setIsUpdating(false));
  };

  if (loading) return <div className="settings-page-wrapper"><div style={{color: 'white'}}>Sistem yükleniyor...</div></div>;
  if (error) return <div className="settings-page-wrapper"><div style={{color: '#FF3B3B'}}>Hata: {error.message}</div></div>;

  const isActive = settings?.bonusRequestsEnabled;

  return (
    <div className="settings-page-wrapper">
      <div className={`settings-card ${isActive ? 'active' : 'inactive'}`}>
        <div className="settings-icon-wrapper">
          <FaShieldAlt />
        </div>
        
        <h2 className="settings-title">Sistem Kontrolü</h2>
        <p className="settings-subtitle">Bonus talep sisteminin genel durumunu buradan yönetebilirsiniz.</p>

        {!isActive && (
          <div className="warning-banner">
            <FaExclamationTriangle />
            <span>Sistem şu an devre dışı. Talepler durduruldu.</span>
          </div>
        )}

        <div className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
          <div className="pulse-dot" />
          {isActive ? "SİSTEM AKTİF" : "SİSTEM KAPALI"}
        </div>

        <div className="control-group">
          <button 
            className={`toggle-btn ${isActive ? 'to-close' : 'to-open'}`}
            onClick={toggleBonusRequests} 
            disabled={isUpdating}
          >
            <FaPowerOff />
            {isUpdating ? "Güncelleniyor..." : (isActive ? "Sistemi Kapat" : "Sistemi Başlat")}
          </button>

          <button className="refresh-btn" onClick={fetchSiteSettings} disabled={isUpdating}>
            <FaSyncAlt /> Verileri Yenile
          </button>
        </div>
      </div>
    </div>
  );
};

export default SiteSettings;